module.exports = __webpack_public_path__ + "img/today.5c2ee57c.svg";